import React from 'react';
import FullPageLoader from '../loaders/FullPageLoader';

interface BlurredLoaderProps {
  isLoading: boolean;
  loadingText?: string;
}

/**
 * Simple wrapper with blurred background and loader.
 *
 * @constructor
 */
const BlurredLoader: React.FC<BlurredLoaderProps> = ({ isLoading, loadingText, children }) => {
  return (
    <div className={'position-relative'}>
      {isLoading && (
        <div className="blur-background">
          <FullPageLoader loadingText={loadingText ? loadingText : 'Loading...'} />
        </div>
      )}
      <div className={isLoading ? 'blur' : undefined}>{children}</div>
    </div>
  );
};

export default BlurredLoader;
